import React, { FC } from "react";
import styled from "styled-components/native";
import { font, text, spacing } from "../../styles/theme";
import Text, { SmallText } from "../../styles/Text";
import { StatusIndicatorStatisticInterface } from "../../../fake-data/dashboardData";
import StatusIndicator from "../StatusIndicator";

const StatisticView = styled.View`
  padding: ${spacing.extraSmall} 0;
  flex: 1;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
`;

const StatisticTextContainer = styled.View`
  display: flex;
  margin-left: ${spacing.medium};
`;

const Number = styled(Text)`
  font-size: ${text.extraLarge.size};
  font-family: ${font.defaultSemiBold};
  flex: 1;
  line-height: 100%;
`;

const StatusIndicatorStatistic: FC<StatusIndicatorStatisticInterface> = ({
  number,
  label,
  dataColor,
}) => (
  <StatisticView>
    <StatusIndicator dataColor={dataColor} />
    <StatisticTextContainer>
      <Number>{number}</Number>
      <SmallText
        style={{
          fontSize: text.small.size,
          lineHeight: "auto",
        }}
      >
        {label}
      </SmallText>
    </StatisticTextContainer>
  </StatisticView>
);

export default StatusIndicatorStatistic;
